export const SYSTEM_ROLES = {
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  MANAGEMENT: "management",
  CAO: "cao",
  STAFF: "staff",
  LIBRARIAN: "librarian",
  HOSTEL_WARDEN: "hostel_warden",
  OPERATIONS_MANAGER: "operations_manager",
  PRINCIPAL: "principal",
  VICE_PRINCIPAL: "vice_principal",
  FACULTY: "faculty",
  ACCOUNTANT: "accountant",
  OTHER: "other",
} as const;

export type SystemRole = (typeof SYSTEM_ROLES)[keyof typeof SYSTEM_ROLES];

export const ROLE_PERMISSIONS: Record<SystemRole, readonly string[]> = {
  [SYSTEM_ROLES.SUPERADMIN]: ["*"],
  [SYSTEM_ROLES.ADMIN]: [
    "organisation.view",
    "organisation.manage",
    "user.view",
    "user.create",
    "user.update",
    "user.deactivate",
    "user.invite",
    "role.view",
    "role.create",
    "role.update",
    "role.assign",
    "team.view",
    "team.create",
    "team.update",
    "task.view.all",
    "task.create",
    "task.update",
    "task.assign",
    "approval.manage",
    "report.view.all",
    "security.view",
    "audit.view",
  ],
  [SYSTEM_ROLES.MANAGEMENT]: [
    "organisation.view",
    "dashboard.view.all",
    "task.view.all",
    "task.create",
    "task.update",
    "task.assign",
    "approval.manage",
    "report.view.all",
    "audit.view",
  ],
  [SYSTEM_ROLES.CAO]: [
    "organisation.view",
    "dashboard.view.all",
    "task.view.all",
    "task.create",
    "task.update",
    "task.assign.operations",
    "team.view.operations",
    "approval.request",
    "report.create.operations",
    "report.view.operations",
  ],
  [SYSTEM_ROLES.STAFF]: [
    "task.view",
    "task.create",
    "task.update",
    "report.create",
    "report.view",
  ],
  [SYSTEM_ROLES.LIBRARIAN]: [
    "task.view",
    "task.create",
    "task.update",
    "report.create",
    "report.view",
  ],
  [SYSTEM_ROLES.HOSTEL_WARDEN]: [
    "task.view",
    "task.create",
    "task.update",
    "team.view.operations",
    "report.create",
    "report.view",
  ],
  [SYSTEM_ROLES.OPERATIONS_MANAGER]: [
    "organisation.view",
    "dashboard.view.all",
    "task.view.all",
    "task.create",
    "task.update",
    "task.assign.operations",
    "team.view.operations",
    "approval.request",
    "report.create.operations",
    "report.view.operations",
  ],
  [SYSTEM_ROLES.PRINCIPAL]: [
    "task.create",
    "task.update",
    "task.review",
    "task.assign.academic",
    "team.view.academic",
    "report.create.academic",
    "report.view.academic",
    "approval.request",
  ],
  [SYSTEM_ROLES.VICE_PRINCIPAL]: [
    "task.create",
    "task.update",
    "task.review",
    "task.assign.academic",
    "team.view.academic",
    "report.create.academic",
    "report.view.academic",
    "approval.request",
  ],
  [SYSTEM_ROLES.FACULTY]: [
    "task.view",
    "task.create",
    "task.update",
    "report.create",
    "report.view",
  ],
  [SYSTEM_ROLES.ACCOUNTANT]: [
    "task.view",
    "task.update",
    "report.create",
    "report.view.all",
  ],
  [SYSTEM_ROLES.OTHER]: [
    "task.view",
  ],
};
